// modules
import React, { useCallback } from 'react';
import { View } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
// store
import { useStore } from 'modules/Stores';
// typings
import { AlertStatusFilter } from 'modules/PriceAlerts/typings';
// components
import PriceAlertsHeader from './components/PriceAlertsHeader';
import PriceAlertsFooter from './components/PriceAlertsFooter';
import PriceAlertsBody from './components/PriceAlertsBody';
// styles
import * as css from './styles';

const PriceAlertsModal = () => {
  const { toggleModal } = useStore('AppStore');
  const { modalType, setSelectedStatus, clearAlertForm } = useStore('PriceAlertsStore');
  const deleteModal = modalType === 'Delete';

  const closeModal = useCallback(() => {
    toggleModal('priceAlerts');
    clearAlertForm();
    setSelectedStatus(AlertStatusFilter.ALL);
  }, [toggleModal, setSelectedStatus, clearAlertForm]);

  return (
    <View css={css.modalContainer}>
      <View css={css.modal}>
        <View
          id="priceAlertsModal"
          flexDirection="column"
          justifyContent="space-between"
          css={css.base}
          cssProps={{
            showLeftBorder: deleteModal,
            deleteModal,
          }}
        >
          <PriceAlertsHeader closeModal={closeModal} />
          <PriceAlertsBody />
          <PriceAlertsFooter />
        </View>
      </View>
    </View>
  );
};

export default observer(PriceAlertsModal);
